<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Date Type">
                                    <a-select
                                        :filterOption="filterOption"
                                        show-search
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        v-model="dateRangeType">
                                        <a-select-option v-for="opt in dateRangeOptions" :key="opt.key" :value="opt.key">{{opt.value}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4" v-if="dateRangeType == 'daily'">
                                <base-input alternative="" label="Select Date"><br>
                                    <a-date-picker v-model="inputDateDay" :allowClear="false" style="width:100%">
                                    </a-date-picker>
                                </base-input>
                            </div>
                            <div class="col-md-4" v-else-if="dateRangeType == 'weekly'">
                                <base-input alternative="" label="Select Week"><br>
                                    <a-week-picker v-model="inputDateWeek" :allowClear="false" picker="week" placeholder="Week" style="width:100%">
                                    </a-week-picker>
                                </base-input>
                            </div>
                            <div class="col-md-4" v-else-if="dateRangeType == 'monthly'">
                                <base-input alternative="" label="Select Month"><br>
                                    <a-month-picker v-model="inputDateMonth" :allowClear="false" picker="month" placeholder="Month" style="width:100%">
                                    </a-month-picker>
                                </base-input>
                            </div>
                            <div class="col-md-4" v-else>
                                <base-input alternative="" label="Select From & To"><br>
                                    <a-range-picker v-model="inputDateRange" :allowClear="false" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row" v-if="site_type == 'ho'">
                            <div class="col-md-4">
                                <base-input label="Location">
                                    <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Group By" >
                                    <a-select
                                        :filterOption="filterOption"
                                        show-search
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        @click.prevent="autoChange"
                                        v-model="inputGroupBy">
                                        <a-select-option v-for="opt in groupOptions" :key="opt.key" :value="opt.key">{{opt.value}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Sort By" >
                                    <a-select
                                        :filterOption="filterOption"
                                        show-search
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        @click.prevent="sortChange"
                                        v-model="inputSortBy">
                                        <a-select-option v-for="opt in sortOptions" :key="opt.key" :value="opt.key">{{opt.value}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                            <div class="col-md-2 mt-3 pt-3">
                                <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                    {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                </button>
                            </div>
                        </div>
    
                        <base-checkbox class="mb-3" v-model="isSeparateSite" v-if="site_type == 'ho'">
                            Separate per site
                        </base-checkbox>
    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
    
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import * as ExcelJS from "exceljs";
        import { saveAs } from "file-saver";
    
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            components: {
                VueJsonToCsv
            },
            data() {
                return {
                    value2:'',
                    spinning: false,
                    inputDateRange: [moment().startOf('day'), moment().endOf('day')],
                    inputDateDay: moment().endOf('day'),
                    inputDateWeek: moment().endOf('week'),
                    inputDateMonth: moment().endOf('month'),
                    inputGroupBy: 'supplier_id',
                    groupOptions: [
                        {key: 'supplier_id', value: 'Supplier'},
                        {key: 'supplier_type_id', value: 'Supplier Type'},
                        {key: 'brand_id', value: 'Brand'},
                        {key: 'division_id', value: 'Division'},
                        {key: 'department_id', value: 'Department'},
                        {key: 'section_id', value: 'Section'},
                        {key: 'category_id', value: 'Category'}
                    ],
                    dateRangeType: 'daily',
                    dateRangeOptions: [
                        {key: 'daily', value: 'Daily'},
                        {key: 'weekly', value: 'Weekly'},
                        {key: 'monthly', value: 'Monthly'},
                        {key: 'daterange', value: 'Date Range'}
                    ],
                    inputSite: [],
                    site_type: "ho",
                    siteOptions: [],
                    inputLocation: [],
                    locationOptions: [],
                    headerExcelInfo: "",
                    // locationPath: [],
    
                    inputSortBy: 'product_id',
                    sortOptions: [
                        {key: 'barcode', value: 'Barcode'},
                        {key: 'product_name', value: 'Name or Description'},
                        {key: 'subtotal', value: 'Total Amount'},
                        {key: 'quantity', value: 'Total Quantity'}
                    ],
                    currDate: moment().format("L_LT").split(":").join(";"),
                    isSeparateSite: false,
                    isShowDetail: true,
                    inputFrom: moment().startOf('month'),
                    inputTo: moment().endOf('month'),
                    monthFormat: 'MM/YYYY',
                    returnsReports: [],
                    params: {},
                    advancedFilterVisible: true,
    
                    showSortInfo: 'asc',
                    inputShowTop: 0,
                    JsonData: [],
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                if(component_x.categoriesOptions.length == 0){
                    var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                    component_x.updateCategoriesOptions(options)
                }
    
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputSite = [siteId]
                
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
            },
            watch: {
                inputGroupBy: function(val){
                    if(this.inputGroupBy == "date,division_id"){
                        this.sortOptions = [
                            {key: 'document_date', value: 'Document Date'},
                            {key: 'date,quantity', value: 'Date and Quantity'},
                            {key: "date,division_id", value: "Date and Division"}
                        ]
                    }else if(this.inputGroupBy == "date,product_group_id"){
                        this.sortOptions = [
                            {key: 'document_date', value: 'Document Date'},
                            {key: 'date,quantity', value: 'Date and Quantity'},
                            {key: "date,product_group_id", value: "Date and Product Group"}
                        ]
                    }
                } 
            },
            computed: {
                ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
            },
            methods: {
                ...mapActions(['updateCategoriesOptions']),
                moment,
                async onLocationChange(){
                    // alert(this.inputLocation);
                    this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                },
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                autoChange(e){
                    if(e.target.value == ''){
                        this.isShowDetail = true
                    }
                },
                sortChange(e){
                    if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                        this.inputShowTop = 0
                    }
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                changeParams(params){
                    this.params = params
                },
                async findName(inputArray, optionsArray){
                    let data = []
                    inputArray.forEach((el) =>{
                        data.push(optionsArray.find(x => x.id === el).name)
                    })
                    return data
                },
                generateReport: async function () {
                    this.spinning = true;
                    var from_date = ''
                    var to_date = ''
    
                    if(this.dateRangeType == 'daterange'){
                        from_date = this.inputDateRange[0].format('YYYY-MM-DD')
                        to_date = this.inputDateRange[1].format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'daily'){
                         from_date = this.inputDateDay.format('YYYY-MM-DD')
                         to_date = this.inputDateDay.format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'weekly'){
                        var curr = new Date(this.inputDateWeek.format('YYYY-MM-DD'));
                        var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
                        var last = first + 6; // last day is the first day + 6
                        from_date = new Date(curr.setDate(first)).toISOString().slice(0, 10);
                        to_date = new Date(curr.setDate(last)).toISOString().slice(0, 10)
                    } else if(this.dateRangeType == 'monthly'){
                         from_date = this.inputDateMonth.format('YYYY-MM-01')
                         to_date = this.inputDateMonth.format('YYYY-MM-'+new Date(this.inputDateMonth.format('YYYY'), this.inputDateMonth.format('MM'), 0).getDate())  
                    }
    
                    let filter_header = '' 
                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "group_by": this.inputGroupBy,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                    }
    
                    if(this.inputSite.length > 0){
                        let arr = await this.findName(this.inputSite, this.siteOptions)
                        filter_header += `Site (${arr})`
                    }else{
                        filter_header += "Site (All Site)"
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'returns_report?', parameters);
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }
                    var siteSpecific = get_request;
                    
                    let design_x = 0
                    let design_y = 0
    
                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }
    
                    if(siteSpecific.length > 0){
                        var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    
                        // let reportLogo = document.getElementById('reportLogo');
                        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                        let description = "Description"
                        if(this.inputGroupBy == "date,division_id"){
                            description = "Division Name"
                        }else if(this.inputGroupBy == "date,product_group_id"){
                            description = "Product Group Name"
                        }
    
                        let headers = [];
                        headers = [
                            [
                                {content: '#', styles: {halign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center'}},
                                {content: 'Description', styles: {halign: 'center'}},
                                {content: 'Retail\nPrice', styles: {halign: 'center'}},
                                {content: 'Average\nPrice', styles: {halign: 'center'}},
                                {content: 'Quantity', styles: {halign: 'center'}},
                                {content: 'Discount', styles: {halign: 'center'}},
                                {content: 'Total\nAmount', styles: {halign: 'center'}},
                                {content: 'Customer', styles: {halign: 'center'}},
                                {content: 'SO Reference', styles: {halign: 'center'}},
                                {content: 'SI Reference', styles: {halign: 'center'}},
                                {content: 'Reason', styles: {halign: 'center'}},
                            ]
                        ]
    
                        for(let x=0; x < siteSpecific.length; x++){
                            this.returnsReports = siteSpecific[x].returns_report
    
                            let total_qty = 0
                            let total_discount = 0
                            let total_returns = 0
                            let grand_qty = 0
                            let grand_discount = 0
                            let grand_returns = 0
        
                            if(x > 0 && this.returnsReports.length > 0){
                                doc.addPage();
                            }
    
                            let reportData = [];
                            let grouper = 'start'
                            let grouper2 = 'start'
    
                            if(this.returnsReports.length > 0){
    
                                let number = 1
                                for(let i=0; i < this.returnsReports.length; i++){
                                    let reportLine = this.returnsReports[i]
    
                                    let grouper_name = moment(reportLine.document_date).format('MMM DD, YYYY')
                                    let grouper_name2 = reportLine.grouper_name
                                    if(this.inputGroupBy != ''){
                                        if(grouper == 'start' || grouper != moment(reportLine.document_date).format('MMM DD, YYYY')){
                                            let detail_header = [
                                                {content: `${grouper_name}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                                ];
                                            reportData.push(Object.assign({}, detail_header))
                                            detail_header = [
                                                {content: `${grouper_name2}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                                ];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else if(grouper2 != reportLine.grouper_id && grouper == moment(reportLine.document_date).format('MMM DD, YYYY')) {
                                                let detail_header = [{content: `${grouper_name2}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                                ];
                                                reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != moment(reportLine.document_date).format('MMM DD, YYYY')){
                                                let detail_header = [{content: `${grouper_name}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                                ];
                                                reportData.push(Object.assign({}, detail_header))
                                                detail_header = [
                                                {content: `${grouper_name2}`, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}
                                                ];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper  = moment(reportLine.document_date).format('MMM DD, YYYY')
                                        grouper2 = reportLine.grouper_id
                                    }
    
                                    let detail = []
                                    let si_ref  = ''
                                    let so_ref = ''
                                    if(reportLine.origin_doc_type_code =='SIN'){
                                        si_ref = String(reportLine.origin_doc_type_code)+'#'+String(reportLine.origin_document_no) || ''
                                        if(reportLine.origin_doc_type_code_c =='SOX'){
                                            so_ref = String(reportLine.origin_doc_type_code_c)+'#'+String(reportLine.origin_document_no_c) || ''
                                        }
                                        if(reportLine.origin_doc_type_code_d =='SOX'){
                                            so_ref = String(reportLine.origin_doc_type_code_d)+'#'+String(reportLine.origin_document_no_d) || ''
                                        }
                                    }
                                    detail = [
                                            number,
                                            reportLine.barcode,
                                            {content: reportLine.product_name, styles: {halign: 'left'}},
                                            this.convertToCurrency(Number(reportLine.retail_price)),
                                            this.convertToCurrency(Number(reportLine.average_price)),
                                            this.convertToCurrency(Number(reportLine.quantity)),
                                            this.convertToCurrency(Number(reportLine.discount)),
                                            this.convertToCurrency(Number(reportLine.subtotal)),
                                            {content: reportLine.b2b_customer || '', styles: {halign: 'left'}},
                                            {content: so_ref || '', styles: {halign: 'left'}},
                                            {content: si_ref || '', styles: {halign: 'left'}},
                                            {content: reportLine.reason || '', styles: {halign: 'left'}},
                                    ]
                                    
                                    reportData.push(Object.assign({}, detail))
                                    number += 1
                                    total_qty += Number(reportLine.quantity)
                                    total_discount += Number(reportLine.discount)
                                    total_returns += Number(reportLine.subtotal)
    
                                    grand_qty += Number(reportLine.quantity)
                                    grand_discount += Number(reportLine.discount)
                                    grand_returns += Number(reportLine.subtotal)
    
                                    if(i == this.returnsReports.length-1){
                                        if(this.inputGroupBy != ''){
                                        let sub_detail = []
                                        let spacer = grouper_name
                                        
                                        // sub_detail = ["",
                                        //             "","","","","Total:",
                                        //             this.convertToCurrency(total_qty),
                                        //             this.convertToCurrency(total_returns)
                                        //         ]
                                        // reportData.push(Object.assign({}, ["rowLine"]))
                                        // reportData.push(Object.assign({}, sub_detail))
                                        }
                                    
    
                                        reportData.push(Object.assign({}, ["rowLine"]))
    
                                        reportData.push(Object.assign({}, ['','','','','Grand Total :', this.convertToCurrency(grand_qty),
                                            this.convertToCurrency(grand_discount), this.convertToCurrency(grand_returns)
                                        ]))
                                    } else {
                                        let current_grouper = ""
                                        let next_grouper = ""
                                        
                                        current_grouper = moment(reportLine.document_date).format('MMM DD, YYYY')
                                        next_grouper = moment(this.returnsReports[i+1].document_date).format('MMM DD, YYYY')
                                    
                                        if(current_grouper != next_grouper){
                                            if(this.inputGroupBy != ''){
                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                let sub_detail = []
    
                                                let spacer = grouper_name
                                                // sub_detail = ["",
                                                //     "","","","","Total:",
                                                //     this.convertToCurrency(total_qty),
                                                //     this.convertToCurrency(total_returns)
                                                // ]
                                                // reportData.push(Object.assign({}, sub_detail))
    
                                                total_qty = 0
                                                total_returns = 0
                                            }
                                            
                                        }
                                    }
                                }
                            }
    
    
                            design_x = 285
                            design_y = 200
                            
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Returns Report" + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            if(this.isSeparateSite == true){
                                try {
                                    doc.text(design_x,20,siteSpecific[x].returns_report[0].site_name,"right");
                                } catch (error) {}
                            } else {
                                let site_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = ''
                                } else {
                                    // let sites = this.inputSite
                                    // for (var s = 0; s < sites.length; s++) {
                                    //     if(s == 0){
                                    //         site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    //     } else {
                                    //         site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    //     }
                                    // }
                                }
                                doc.text(design_x,20,site_text,"right");
                            }
                            doc.text(15,25,"For the Period of " + from_date + " to " + to_date)
    
                            let splitTitle = doc.splitTextToSize("Filtered by: " + filter_header, 180);
                            doc.text(15,30,splitTitle);
    
                            let colStyles = {}
    
                            colStyles = {
                                0: {cellWidth: 10},
                                1: {cellWidth: 25},
                                2: {cellWidth: 45},
                                3: {cellWidth: 20},
                                4: {cellWidth: 20},
                                5: {cellWidth: 15},
                                6: {cellWidth: 22},
                                7: {cellWidth: 22},
                                8: {cellWidth: 22},
                                9: {cellWidth: 23},
                                10: {cellWidth: 23},
                                11: {cellWidth: 22},
                            }
    
    
                            doc.autoTable({
                                startY: 45,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                },
                                margin: { bottom: 20 },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right',
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });
    
                        }
                        // end loop
    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
    
                        let pageCount = doc.internal.getNumberOfPages();
                        
                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Returns Report" + group_text, design_x, design_y, i, pageCount)
                        }
                        window.open(URL.createObjectURL(doc.output("blob")))
                    } else {
                        reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
    
                },
                getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                        console.log(dataURL)
                    }
                    return img.src = url
                },
                async generateExcel(){
                    const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("Return Report", {
                        pageSetup:{paperSize: 9}
                    });

                    var from_date = ''
                    var to_date = ''
    
                    if(this.dateRangeType == 'daterange'){
                        from_date = this.inputDateRange[0].format('YYYY-MM-DD')
                        to_date = this.inputDateRange[1].format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'daily'){
                         from_date = this.inputDateDay.format('YYYY-MM-DD')
                         to_date = this.inputDateDay.format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'weekly'){
                        var curr = new Date(this.inputDateWeek.format('YYYY-MM-DD'));
                        var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
                        var last = first + 6; // last day is the first day + 6
                        from_date = new Date(curr.setDate(first)).toISOString().slice(0, 10);
                        to_date = new Date(curr.setDate(last)).toISOString().slice(0, 10)
                    } else if(this.dateRangeType == 'monthly'){
                         from_date = this.inputDateMonth.format('YYYY-MM-01')
                         to_date = this.inputDateMonth.format('YYYY-MM-'+new Date(this.inputDateMonth.format('YYYY'), this.inputDateMonth.format('MM'), 0).getDate())  
                    }
    
                    let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    const data_starts_at_row = 8
    
                    //let reportLogo = document.getElementById('reportLogo');
                
                    //const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    // const imageId2 = workbook.addImage({
                    //     base64: base64Image,
                    //     extension: 'png',
                    // });
    
                    // sheet.addImage(imageId2, {
                    //     tl: { col: 0, row: 0 },
                    //     ext: { width: 61, height: 61 }
                    // });
    
                    sheet.getRow(4).values = ["Return Report"]
                    sheet.getRow(5).values = [`For the Period of ${from_date} to ${to_date}`]
                    sheet.getRow(6).values = [`Filtered by: ${status_header}${filter_header}}`]
    
                    //custom header
                    sheet.getRow(data_starts_at_row).values = ["#", 
                        "Barcode", "Description",
                        "Retail Price", "Average Price", "Quantity","Discount","Total Amount",
                        "Customer", "SO Reference", "SI Reference", "Reason"];
    
                    sheet.columns = [
                        { key: "#" , width: 20 },
                        { key: "barcode" , width: 20 },
                        { key: "desc", width: 45 },
                        { key: "retail_price", width: 15 },
                        { key: "avg_price", width: 15 },
                        { key: "qty", width: 15 },
                        { key: "discount" , width: 15 },
                        { key: "total_amount" , width: 15 },
                        { key: "b2b_customer" , width: 15 },
                        { key: "so_ref" , width: 15 },
                        { key: "si_ref" , width: 15 },
                        { key: "reason" , width: 15 },
                    ];
                    
                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    console.log("details", report_details)
                    console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0
                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]
                            if(report_detail){
                                const rowData = {"#": report_detail["#"], desc: report_detail["Description"], barcode: report_detail["Barcode"], 
                                landed_cost: report_detail["Landed Cost"], qty: report_detail["Quantity"], discount: report_detail["Discount"],
                                avg_price: report_detail["Average Price"], avg_cost: report_detail["Average Cost"], retail_price: report_detail["Retail Price"], stock_no: report_detail["Stock No"], gross_price: report_detail["Gross Price"], 
                                total_amount: report_detail["Total Amount"], b2b_customer: report_detail["Customer"], so_ref: report_detail["SO Reference"],si_ref: report_detail["SI Reference"], reason: report_detail["Reason"] }
                                rowDatas.push(rowData)
                            }
                        }
    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(4).font = { bold: true, size: 16 };
                    sheet.getRow(4).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `ReturnsReport.xlsx`);
                    });
                    this.JsonData = []
                },
                generateFile: async function() {
    
                    var from_date = ''
                    var to_date = ''
    
                    if(this.dateRangeType == 'daterange'){
                        from_date = this.inputDateRange[0].format('YYYY-MM-DD')
                        to_date = this.inputDateRange[1].format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'daily'){
                         from_date = this.inputDateDay.format('YYYY-MM-DD')
                         to_date = this.inputDateDay.format('YYYY-MM-DD')
                    } else if(this.dateRangeType == 'weekly'){
                        var curr = new Date(this.inputDateWeek.format('YYYY-MM-DD'));
                        var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
                        var last = first + 6; // last day is the first day + 6
                        from_date = new Date(curr.setDate(first)).toISOString().slice(0, 10);
                        to_date = new Date(curr.setDate(last)).toISOString().slice(0, 10)
                    } else if(this.dateRangeType == 'monthly'){
                         from_date = this.inputDateMonth.format('YYYY-MM-01')
                         to_date = this.inputDateMonth.format('YYYY-MM-'+new Date(this.inputDateMonth.format('YYYY'), this.inputDateMonth.format('MM'), 0).getDate())  
                    }
    
                    let filter_header = '' 
                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "group_by": this.inputGroupBy,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                    }
    
                    if(this.inputSite.length > 0){
                        let arr = await this.findName(this.inputSite, this.siteOptions)
                        filter_header += `Site (${arr})`
                    }else{
                        filter_header += "Site (All Site)"
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'returns_report?', parameters);
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }
                
                    if(get_request.length > 0){
                        let siteSpecific = get_request;
                        let description = "Description"
                        if(this.inputGroupBy == "date,division_id"){
                            description = "Division Name"
                        }else if(this.inputGroupBy == "date,product_group_id"){
                            description = "Product Group Name"
                        }
                        let headers = ["#", "Barcode", "Description", "Retail Price", "Average Price", "Quantity", "Discount", "Total Amount","Customer","SO Reference", "SI Reference", "Reason"];
                        let site_specific = [];
    
                        for(let x=0; x < siteSpecific.length; x++){
                            this.returnsReports = siteSpecific[x].returns_report
    
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
    
                            if(this.returnsReports.length > 0){
                                let total_qty = 0
                                let total_discount = 0
                                let total_returns = 0
                                let grand_qty = 0
                                let grand_discount = 0
                                let grand_returns = 0
    
                                let grouper = 'start'
                                let grouper2 = 'start'
                                let number = 1
                                for(let i=0; i < this.returnsReports.length; i++){
                                    let reportLine = this.returnsReports[i]
                                    let grouper_name = moment(reportLine.document_date).format('MMM DD, YYYY')
                                    let grouper_name2 = reportLine.grouper_name
                                    if(grouper == 'start' || grouper != moment(reportLine.document_date).format('MMM DD, YYYY')){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                        detail_header = [grouper_name2];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else if(grouper2 != reportLine.grouper_id && grouper == moment(reportLine.document_date).format('MMM DD, YYYY')) { 
                                        let detail_header = [grouper_name2];
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != moment(reportLine.document_date).format('MMM DD, YYYY')){
                                            let detail_header = [grouper_name];
                                            reportData.push(Object.assign({}, detail_header))
                                            detail_header = [grouper_name2];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper  = moment(reportLine.document_date).format('MMM DD, YYYY')
                                    grouper2 = reportLine.grouper_id
                                    let si_ref = ''
                                    let so_ref = ''
                                    if(reportLine.origin_doc_type_code =='SIN'){
                                        si_ref = String(reportLine.origin_doc_type_code)+'#'+String(reportLine.origin_document_no) || ''
                                        if(reportLine.origin_doc_type_code_c =='SOX'){
                                            so_ref = String(reportLine.origin_doc_type_code_c)+'#'+String(reportLine.origin_document_no_c) || ''
                                        }
                                        if(reportLine.origin_doc_type_code_d =='SOX'){
                                            so_ref = String(reportLine.origin_doc_type_code_d)+'#'+String(reportLine.origin_document_no_d) || ''
                                        }
                                    }
                                    let detail = []
                                    detail = [
                                        number,
                                        reportLine.barcode,
                                        reportLine.product_name,
                                        this.convertToCurrency(Number(reportLine.retail_price)),
                                        this.convertToCurrency(Number(reportLine.average_price)),
                                        this.convertToCurrency(Number(reportLine.quantity)),
                                        this.convertToCurrency(Number(reportLine.discount)),
                                        this.convertToCurrency(Number(reportLine.subtotal)),
                                        reportLine.b2b_customer || '',
                                        so_ref || '',
                                        si_ref || '',
                                        reportLine.reason || ''
                                    ]
                                    number += 1
                                    total_qty += Number(reportLine.quantity)
                                    total_discount +=Number(reportLine.discount)
                                    total_returns += Number(reportLine.subtotal)
    
                                    grand_qty += Number(reportLine.quantity)
                                    grand_discount += Number(reportLine.discount)
                                    grand_returns += Number(reportLine.subtotal)
    
                                    reportData.push(Object.assign({}, detail))
    
                                    // let sub_detail = []
                                    if(i == this.returnsReports.length-1){
                                        //Subtotal
                                        // sub_detail = ['','','','','','Sub Total :',
                                        //         this.convertToCurrency(total_qty),
                                        //         this.convertToCurrency(total_returns)
                                        //     ]
                                        // reportData.push(Object.assign({}, sub_detail))
    
                                        //Grand Total
                                        let grand_detail = ['','','','','Grand Total :',
                                            this.convertToCurrency(grand_qty),
                                            this.convertToCurrency(grand_discount),
                                            this.convertToCurrency(grand_returns)
                                        ]
                                        reportData.push(Object.assign({}, grand_detail));
                                    } else {
                                        let current_grouper = ""
                                        let next_grouper = ""
    
                                        current_grouper = moment(reportLine.document_date).format('MMM DD, YYYY')
                                        next_grouper = moment(this.returnsReports[i+1].document_date).format('MMM DD, YYYY')
    
                                        if(current_grouper != next_grouper){
                                            //Subtotal
                                            // sub_detail = ['','','','','','Sub Total :',
                                            //     this.convertToCurrency(total_qty),
                                            //     this.convertToCurrency(total_returns)
                                            // ]
    
                                            // reportData.push(Object.assign({}, sub_detail))
    
                                            total_qty = 0
                                            total_returns = 0
                                        }
                                    }
                                }
    
                            }
    
                            let group_text = ""
                            if(this.inputGroupBy != ''){
                                group_text = " by " + this.sortOptions[0].value
                            }
    
                            if(this.isSeparateSite == true){
                                reportData.unshift([siteSpecific[x].returns_report[0].site_name]);
                            } else {
                                let site_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'All Sites'
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                        }
                                    }
                                }
                                reportData.unshift([site_text]);
                            }
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            reportData.push(["Returns Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                            reportData.push([])
    
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
                },
                clearJsonData(){
                 this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>
    